export default __webpack_public_path__ + "static/media/Crash.3028beaa.wav";